import React from 'react'
import './Banner.css'

const Banner = () => {
    return (
        <section className='Banner'>
            <div className='container'>
                <div className='banner_holder'>
                    <img src={process.env.PUBLIC_URL + "/assets/images/career/banner/banner.png"} className='banner_img' />
                </div>
            </div>
        </section>
    )
}

export default Banner
